import api from "./api";

export async function getFullDocument(
  documentId: string,
  query?: {
    include_questions?: boolean;
    include_knowledge_base?: boolean;
    include_slides?: boolean;
  }
) {
  // query to url search params
  const searchParams = new URLSearchParams();
  for (const [key, value] of Object.entries(query || {})) {
    searchParams.append(key, value.toString());
  }

  const response = await api.get(
    `/documents/${documentId}/full?${searchParams.toString()}`
  );
  return response.data;
}
